import {
  OrgSiteListEntry,
  Organisation,
} from "@inrange/building-manager-api-client/models-organisation";
import React from "react";
import formatCurrency from "../../formatting/formatCurrency";
import { formatUnits } from "../../formatting/formatKiloUnits";
import formatPercentage from "../../formatting/formatPercentage";
import HealthIndicatorCell from "./HealthIndicatorCell";
import SiteLink from "./SiteLink";
import SiteNameAddressData from "./SiteNameAddressData";
import TableCellData from "./TableCellData";

const OperationalTenantSiteRow: React.FC<{
  site: OrgSiteListEntry;
  organisation: Organisation;
  mode: string;
  lastMonthCost: number;
  lastMonthProcurement: number;
  lastMonthRevenue: number;
  lastMonthDemandFulfilled: number;
  lastMonthSavings: number;
  lastMonthGeneration: number;
  hideSavings?: boolean;
  isOfftakerOnly?: boolean;
  showHealthIndicator?: boolean;
}> = ({
  site,
  organisation,
  mode,
  lastMonthCost,
  lastMonthProcurement,
  lastMonthRevenue,
  lastMonthDemandFulfilled,
  lastMonthSavings,
  lastMonthGeneration,
  hideSavings,
  isOfftakerOnly,
  showHealthIndicator,
}) => {
  return (
    <tr key={site.id} id={site.id}>
      {showHealthIndicator && <HealthIndicatorCell />}
      <td>
        <TableCellData>
          <SiteNameAddressData
            siteName={site.name}
            siteAddress={site.address}
            siteId={site.id}
            orgId={organisation.id}
          />
        </TableCellData>
      </td>
      <td>
        <TableCellData>
          {formatCurrency(lastMonthCost, site.currencyCode, 2)}
        </TableCellData>
      </td>
      <td>
        <TableCellData>
          {formatUnits(lastMonthProcurement, "kWh", 2)}
        </TableCellData>
      </td>
      {!isOfftakerOnly &&
        (mode === "leased" ? (
          <td>
            <TableCellData>
              {formatPercentage(lastMonthDemandFulfilled, 0)}
            </TableCellData>
          </td>
        ) : (
          <td>
            <TableCellData>
              {formatCurrency(lastMonthRevenue, site.currencyCode, 2)}
            </TableCellData>
          </td>
        ))}
      {!hideSavings && !isOfftakerOnly && (
        <td>
          <TableCellData>
            {formatCurrency(lastMonthSavings, site.currencyCode, 2)}
          </TableCellData>
        </td>
      )}
      {!isOfftakerOnly && (
        <td>
          <TableCellData>
            {formatUnits(lastMonthGeneration, "kWh", 2)}
          </TableCellData>
        </td>
      )}
      <td style={{ width: "170px" }}>
        <SiteLink siteId={site.id} orgId={organisation.id} />
      </td>
    </tr>
  );
};

export default OperationalTenantSiteRow;
